import { Link } from 'element-ui'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  zh: {
    logout: {
      confirm: '确认退出登录吗？',
      tip: '提示',
      confirmBtn: '确定',
      cancelBtn: '取消',
      success: '退出成功',
      loginseccess: '登录成功',
      chongzhimima: '重置密码成功',
    },
    nav: {
      // des: localStorage.getItem('description'),
      home: '首页',
      language: 'EN',
      company:{
        surun: '江苏苏润人才发展集团有限公司',
        running:'南京润宁科技发展有限公司',
        runjiang:'扬州润江人才发展有限公司',
        runtong:'南通润通人才服务有限公司',
        runan:'淮安润安人才发展有限公司',
      },
      title:{
        tro:'集团概况',
        link:'友情链接',
        contact:'联系我们',
      },
      copyright: '版权所有：江苏苏润人才发展集团有限公司',
      contact:{
        phone:'联系电话',
        email:'邮箱',
        location:'地址',
        sao:'海外人才招引：扫一扫下方二维码',
      },
      login1: {
        passdeng: '密码登录',
        dongtaideng:'动态登录',
        phone:'请输入手机号',
        password: '请输入密码',
        yanzhengma: '请输入验证码',
        getyanzhengma: '获取验证码',
        chongshi: '秒后重试',
        forgetpassword: '忘记密码',
        login: '登录',
        meizhanghao: '还没有账号？立即注册账号',
        zhuce: '注册账号',
        nick: '昵称',
        shurunick: '请输入昵称',
        formphone: '手机号',
        yzm: '验证码',
        formpassword: '密码',
        querenpassword: '确认密码',
        formquerenpassword: '请输入确认密码',
        zhuce1: '注册',
        youzhanghao: '已有账号？立即登录',
        chongzhimima: '重置密码'
      },
      group: {
        title: '集团概况',
        intro: '集团简介',
        members: '成员企业',
        culture: '企业文化',
        products: '服务产品',
        history: '发展历程',
        honors: '集团荣誉',
        partners: '合作伙伴',
        contact: '联系方式',
        join: '加入我们'
      },
      talent: {
        title: '人才服务',
        lifecycle: '人才全生命周期服务',
        plan: '人才计划解读',
        policy: '人才政策',
        recruitment: '人才招聘',
        recommendation: '人才推荐'
      },
      enterprise: {
        title: '企业服务',
        lifecycle: '企业全生命周期服务',
        policy: '惠企政策'
      },
      government: {
        title: '政府服务',
        service: '政府服务',
        cooperation: '合作政府推介',
        innovation: '科创载体'
      },
      activities: '科创活动',
      news: '新闻动态',
      courses: '课程中心',
      experts: {
        title: '人才专家库',
        database: '人才专家库',
        interviews: '人才采访视频'
      },
      apply: '即刻申报',
      searchPlaceholder: '搜索...',
      login: '登录',
      register: '注册',
      userCenter: '个人',
      userCenter1:'中心',
      logout: '退出'
    },
    footer: {
      about: '关于我们',
      aboutText: '这里是公司简介文字...',
      contact: '联系方式',
      address: '地址：XXX',
      phone: '电话：XXX',
      email: '邮箱：XXX',
      followUs: '关注我们',
      copyright: '版权所有'
    },
    home: {
      companyCulture: '企业文化',
      developmentHistory: '发展历程',
      viewMore: '查看更多',
      wantToKnowMore: '想了解更多关于苏润？',
      wantToKnowMoreEn: 'WANT TO KNOW MORE ABOUT SURUN?',
      more: '了解更多',
    },
    group: {
      intro: '集团简介',
      members: '成员企业',
      culture: '企业文化',
      products: '服务产品',
      history: '发展历程',
      honors: '集团荣誉',
      partners: '合作伙伴',
      contact: '联系方式',
      join: '加入我们',
      viewNow: '点击查看'
    },
    talentPage: {
      lifecycle: '人才全生命周期服务',
      cases: '人才服务案例',
      standard: '人才服务标准'
    },
    enterpriseLifecycle: {
      lifecycle: '企业全生命周期服务',
      luodi: '企业落地服务',
      innovation: '创新资质管理',
      system: '创新体系建设',
      resource: '创新资源对接'
    },
    governmentService: {
      service: '政府服务',
      cases: '高层次人才集聚工程',
      standard: '科技创新异地孵化工程',
      resource: '高企、科创项目培育、引进',
      cultivation: '产业集群培育',
      double:'双创全链孵化',
      two:'双招双引'
    },
    talentPlan: {
      title: '人才计划解读',
      titleEn: '人才计划解读',
      sections: {
        national: '国家级人才计划解读',
        provincial: '省级人才计划解读',
        city: '地市级人才计划解读'
      }
    },
    talentPolicy: {
      breadcrumb: {
        home: '首页',
        talent: '人才服务',
        policy: '人才政策'
      },
      filter: {
        area: '地区：',
        city: '城市：',
        all: '全部'
      },
      empty: {
        text: '暂无政策信息'
      },
      button: {
        viewDetail: '查看详情'
      },
      date: '发布时间：'
    },
    cities: {
      nanjing: '南京市',
      wuxi: '无锡市',
      xuzhou: '徐州市',
      changzhou: '常州市',
      suzhou: '苏州市',
      nantong: '南通市',
      lianyungang: '连云港市',
      huaian: '淮安市',
      yancheng: '盐城市',
      yangzhou: '扬州市',
      zhenjiang: '镇江市',
      taizhou: '泰州市',
      suqian: '宿迁市',
      jiangsu: '江苏'
    },
    recruitment: {
      breadcrumb: {
        home: '首页',
        talent: '人才服务',
        recruitment: '人才招聘'
      },
      filter: {
        category: '分类：',
        all: '全部'
      },
      categories: {
        powerEquipment: '新型电力装备',
        newEnergy: '新能源',
        iot: '物联网',
        biomedical: '生物医药',
        textiles: '高端纺织',
        newMaterials: '新材料',
        semiconductor: '半导体',
        equipment: '高端装备',
        aerospace: '航空航天',
        shipbuilding: '高技术船舶与海工装备',
        newEnergyVehicles: '新能源汽车',
        infoComm: '新一代信息通信',
        environmental: '节能环保',
        newFood: '新型食品',
        software: '软件与信息服务',
        digital: '新兴数字产业',
        other: '其他'
      },
      empty: {
        text: '暂无招聘信息'
      }
    },
    recommend: {
      breadcrumb: {
        home: '首页',
        talent: '人才服务',
        recommend: '人才推荐'
      },
      filter: {
        category: '分类：',
        all: '全部'
      },
      empty: {
        text: '暂无推荐信息'
      }
    },
    talentPlanDetail: {
      home: '首页',
      talent: '人才服务',
      plan: '人才计划解读',
      country:'国家级人才计划解读详情',
      Provincial:'省级人才计划解读详情',
      City:'地市级人才计划解读详情',
      time: '发布时间',
      location:'快捷报名',
      title: '人才计划解读详情',
    },
    recruitmentDetail: {
      home: '首页',
      talent: '人才服务',
      recruitment: '人才招聘',
      detail: '人才招聘详情',
      time: '发布时间',
      location:'快捷报名',
      title: '人才招聘详情',
      name: '用户姓名',
      level: '最高学历',
      school: '毕业学校',
      major: '专业',
      phone:'手机号/微信号',
      needs:'您的需求',
      message:'留言',
      highschool: '高校院所求职',
      enterprise: '企业求职',
      startup: '创业落地',
      product: '产学研合作',
    },
    recommendDetail: {
      breadcrumb: {
        home: '首页',
        talent: '人才服务',
        recommend: '人才推荐',
        detail: '人才推荐详情'
      },
      title: '人才推荐详情',
      publishTime: '发布时间：'
    },
    enterprisePolicy: {
      breadcrumb: {
        home: '首页',
        enterprise: '企业服务',
        policy: '惠企政策'
      },
      filter: {
        policyType: '政策类型：',
        all: '全部'
      },
      types: {
        development: '发改类',
        industry: '工信类',
        science: '科技类',
        humanResource: '人社类',
        other: '其他类'
      },
      empty: {
        text: '暂无政策信息'
      },
      button: {
        viewDetail: '查看详情'
      },
      publishTime: '发布时间：'
    },
    governmentCooperation: {
      breadcrumb: {
        home: '首页',
        government: '政府服务',
        cooperation: '合作政府推介'
      },
      filter: {
        area: '地区：',
        city: '城市：',
        all: '全部'
      },
      empty: {
        text: '暂无相关信息'
      },
      publishTime: '发布时间：'
    },
    governmentCooperationDetail: {
      breadcrumb: {
        home: '首页',
        government: '政府服务',
        cooperation: '合作政府推介',
        detail: '合作政府推介详情'
      },
      publishTime: '发布时间：'
    },
    governmentInnovation: {
      breadcrumb: {
        home: '首页',
        government: '政府服务',
        innovation: '科创载体'
      },
      filter: {
        area: '地区：',
        city: '城市：',
        all: '全部'
      },
      empty: {
        text: '暂无相关信息'
      },
      publishTime: '发布时间：'
    },
    governmentInnovationDetail: {
      breadcrumb: {
        home: '首页',
        government: '政府服务',
        innovation: '科创载体',
        detail: '科创载体详情'
      },
      publishTime: '发布时间：',
      title: '科创载体详情'
    },
    activity: {
      breadcrumb: {
        home: '首页',
        activity: '科创活动'
      },
      filter: {
        activityType: '活动类型：',
        all: '全部'
      },
      types: {
        surun: '苏润承办',
        monthly: '月历'
      },
      empty: {
        text: '暂无活动信息'
      },
      time: '时间：'
    },
    activityDetail: {
      breadcrumb: {
        home: '首页',
        activity: '科创活动',
        detail: '活动详情',
        userCenter: '个人中心'
      },
      publishTime: '发布时间：',
      title: '科创活动详情',
      quickApply: '快捷报名',
      collect: {
        collected: '已收藏',
        uncollected: '收藏'
      },
      form: {
        title: '快捷报名',
        name: '用户姓名',
        degree: '最高学历',
        school: '毕业学校',
        major: '专业',
        contact: '手机号/微信号',
        needs: '您的需求',
        message: '留言',
        submit: '提交信息',
        placeholder: {
          name: '请输入姓名',
          degree: '请输入最高学历',
          school: '请输入毕业学校',
          major: '请输入专业',
          contact: '请输入手机号/微信号',
          message: '请输入留言'
        },
        validation: {
          name: '请输入姓名',
          degree: '请输入最高学历',
          school: '请输入毕业学校',
          major: '请输入专业',
          contact: '请输入手机号/微信号',
          needs: '请至少选择一项需求',
          message: '请输入留言'
        }
      },
      needOptions: ['高校院所求职', '企业求职', '创业落地', '产学研合作']
    },
    news: {
      breadcrumb: {
        home: '首页',
        news: '新闻动态'
      },
      filter: {
        newsType: '活动类型：',
        all: '全部'
      },
      types: {
        group: '集团新闻',
        industry: '行业新闻',
        notice: '通知公告'
      },
      empty: {
        text: '暂无新闻信息'
      },
      publishTime: '发布时间：',
      viewDetail: '查看详情'
    },
    newsDetail: {
      breadcrumb: {
        home: '首页',
        news: '新闻资讯',
        detail: '新闻资讯详情'
      },
      publishTime: '发布时间：'
    },
    courses: {
      breadcrumb: {
        home: '首页',
        courses: '课程中心'
      },
      filter: {
        courseType: '课程类型：',
        all: '全部'
      },
      types: {
        public: '公益课程',
        vip: 'VIP课程'
      },
      empty: {
        text: '暂无课程信息'
      },
      vipLock: {
        text: 'VIP专享',
        warning: '该课程仅限 VIP 用户观看，请先开通 VIP'
      },
      // load:{
      //   warning:''
      // }
    },
    coursesDetail: {
      breadcrumb: {
        home: '首页',
        courses: '课程中心',
        detail: '课程详情'
      },
      publishTime: '发布时间：',
      videoTitle: '视频课程',
      contentTitle: '课程内容详情'
    },
    expert: {
      breadcrumb: {
        home: '首页',
        expert: '人才专家库'
      },
      filter: {
        type: '类型：',
        category: '分类：',
        all: '全部'
      },
      types: {
        talent: '人才库',
        expert: '专家库'
      },
      empty: {
        text: '暂无相关信息'
      },
      categories: {
        powerEquipment: '新型电力装备',
        newEnergy: '新能源',
        iot: '物联网',
        biomedical: '生物医药',
        textiles: '高端纺织',
        newMaterials: '新材料',
        semiconductor: '半导体',
        equipment: '高端装备',
        aerospace: '航空航天',
        shipbuilding: '高技术船舶与海工装备',
        newEnergyVehicles: '新能源汽车',
        infoComm: '新一代信息通信',
        environmental: '节能环保',
        newFood: '新型食品',
        software: '软件与信息服务',
        digital: '新兴数字产业',
        other: '其他'
      }
    },
    expertDetail: {
      breadcrumb: {
        home: '首页',
        expert: '人才专家库',
        detail: '人才专家库详情'
      },
      category: {
        title: '所属分类：',
        talent: '人才',
        expert: '专家'
      },
      type: '人才分类：',
      title: '人才专家详情'
    },
    interviews: {
      breadcrumb: {
        home: '首页',
        interviews: '人才采访视频'
      },
      empty: {
        text: '暂无视频信息'
      },
      time: '时间：'
    },
    userCenter: {
      changeAvatar: {
        text: '更换头像'
      },
      changePhone: {
        title: '修改绑定手机',
        newPhone: '请输入新手机号',
        code: '请输入验证码',
        getCode: '获取验证码',
        retryCode: '秒后重试',
        save: '保存'
      },
      tabs: {
        savedPolicy: '收藏的政策',
        savedActivity: '收藏的活动',
        registeredActivity: '报名管理'
      },
      filter: {
        category: '分类：',
        all: '全部',
        talent: '人才政策',
        enterprise: '惠企政策'
      },
      empty: {
        policy: '暂无收藏的政策',
        talentPolicy: '暂无收藏的人才政策',
        enterprisePolicy: '暂无收藏的惠企政策',
        activity: '暂无收藏的活动',
        signedActivity: '暂无报名的活动'
      }
    },
    policyDetail: {
      breadcrumb: {
        home: '首页',
        userCenter: '个人中心',
        talent: '人才服务',
        policy: '人才政策',
        detail: '政策详情'
      },
      publishTime: '发布时间：',
      collect: {
        collected: '已收藏',
        uncollected: '收藏'
      }
    },
    enterprisePolicyDetail: {
      breadcrumb: {
        home: '首页',
        userCenter: '个人中心',
        enterprise: '企业服务',
        policy: '惠企政策',
        detail: '政策详情'
      },
      publishTime: '发布时间：',
      collect: {
        collected: '已收藏',
        uncollected: '收藏'
      }
    },
    applyNow: {
      breadcrumb: {
        home: '首页',
        current: '即刻申报'
      },
      title: '即刻申报',
      sections: {
        basic: '基础信息',
        materials: '申请材料',
        intention: '发展意向',
        consultant: '对接顾问'
      },
      materialsTip: '请提交真实、完整的申请材料，以便进行资格评估与人才引进审核',
      fields: {
        fullName: '姓名',
        passportNumber: '护照号码',
        consultant: '对接顾问'
      },
      placeholders: {
        fullName: '请输入与证件一致的姓名',
        passportNumber: '请输入护照号码（用于身份统一识别）',
        publicationText: '请填写论文标题、发表期刊/会议或DOI等信息',
        developmentIntention: '请简要描述您的研究方向、专业兴趣或拟合作/落地的行业与机构方向',
        consultant: '请填写与您联系的顾问姓名或邀请您申报的对接人员姓名'
      },
      categories: {
        cv: '学术简历（CV）',
        identity: '护照及身份证明文件',
        academic_certificate: '学历与学位证明',
        employment: '工作与任职证明',
        project_experience: '项目经历证明',
        publication: '代表性成果（论文）',
        additional: '其他支撑材料（选填）'
      },
      hints: {
        cv: '请上传完整学术简历（CV），包括教育背景、工作经历及科研成果等信息（支持多个文件）',
        identity: '上传护照信息页扫描件；中国籍(含港澳台)申请人需同时提供身份证或等效身份证明文件(上传至同一栏即可）',
        academic_certificate: '请上传本、硕、博阶段相关学历及学位证明材料，建议尽可能提供完整学习经历文件',
        employment: '请上传工作经历及任职相关证明材料，建议覆盖完整职业履历',
        project_experience: '请上传您主持或参与的项目相关证明材料，例如项目立项证明、结题报告、项目合同、成果证明或其他相关材料',
        publication: '请填写成果信息或上传相关文件（至少选择一种）',
        additional: '可上传其他有助于评估的补充材料，例如专利证明、获奖证书、科研报告或其他相关成果材料'
      },
      uploadPublicationFiles: '上传成果文件（支持多个文件）',
      uploadBtn: '点击上传',
      uploading: '上传中',
      submitTip: '提交即表示您确认所提供信息真实、完整，并同意用于人才评估与引进审核',
      submitBtn: '提交申报',
      submitSuccess: '提交成功',
      submitSuccessConfirm: '确认',
      uploadSuccess: '文件上传成功',
      removeSuccess: '文件已删除',
      agreement: {
        title: '信息保密声明',
        description: '为保障您的个人信息安全，所有提交材料仅用于人才评估与引进审核。请在提交前阅读并同意相关条款。',
        accept: '同意并继续',
        close: '关闭'
      },
      validation: {
        fullName: '请输入姓名',
        passportNumber: '请输入护照号码',
        consultant: '请填写对接顾问姓名',
        categoryRequired: '请至少上传一份{name}',
        publicationRequired: '请填写论文信息或至少上传一份代表性成果文件',
        fileType: '不支持的文件格式，允许：pdf, doc, docx, xls, xlsx, ppt, pptx, zip, rar, 7z, jpg, jpeg, png',
        fileSize: '单个文件大小不能超过 500MB',
        totalSize: '累计上传大小不能超过 2GB',
        agreementFirst: '请先阅读并同意保密协议'
      }
    }
  },
  en: {
    logout: {
      confirm: 'Are you sure to logout?',
      tip: 'Tip',
      confirmBtn: 'OK',
      cancelBtn: 'Cancel',
      success: 'Logout successful',
      loginseccess: 'Login successful',
      chongzhimima: 'Password reset successful',
    },
    nav: {
      // des: localStorage.getItem('descriptionen'),
      home: 'Home',
      language: '中',
      title:{
        tro:'Group',
        link:'Link',
        contact:'Contact',
      },
      company:{
        surun: 'Jiangsu Surun Talent Development Group Co., Ltd.',
        running:'Nanjing Running Technology Development Co., Ltd.',
        runjiang:'Yangzhou Runjiang Talent Development Co., Ltd.',
        runtong:'Nantong Runtong Talent Service Co., Ltd.',
        runan:'Huaian Runan Talent Development Co., Ltd.',
      },
      copyright: 'Copyright: Jiangsu Surun Talent Development Group Co., Ltd.',
      contact:{
        phone:'Phone',
        email:'Email',
        location:'Address',
        sao:'Overseas talent recruitment: scan the QR code below',
      },
      "login1": {
        passdeng: "Password",
        dongtaideng: "Dynamic",
        phone: "Please enter your phone number",
        password: "Please enter your password",
        yanzhengma: "Please enter the verification code",
        getyanzhengma: "Get Code",
        chongshi: "s to retry",
        forgetpassword: "Forgot Password",
        login: "Login",
        meizhanghao: "Don't have an account? Register now",
        zhuce: "Register",
        nick: "Nickname",
        shurunick: "Please enter your nickname",
        formphone: "Phone Number",
        yzm: "Verification Code",
        formpassword: "Password",
        querenpassword: "Confirm Password",
        formquerenpassword: "Please confirm your password",
        zhuce1: "Register",
        youzhanghao: "Already have an account? Login now",
        chongzhimima: "Reset Password"
      },
      group: {
        title: 'Group',
        intro: 'Intro',
        members: 'Members',
        culture: 'Culture',
        products: 'Products',
        history: 'History',
        honors: 'Honors',
        partners: 'Partners',
        contact: 'Contact',
        join: 'Join'
      },
      talent: {
        title: 'Talent',
        lifecycle: 'Lifecycle',
        plan: 'Program',
        policy: 'Policy',
        recruitment: 'Recruitment',
        recommendation: 'Recommend'
      },
      enterprise: {
        title: 'Enterprise',
        lifecycle: 'Lifecycle',
        policy: 'Policy'
      },
      government: {
        title: 'GovtServices',
        service: 'Services',
        cooperation: 'Cooperation',
        innovation: 'Innovation'
      },
      activities: 'Activities',
      news: 'News',
      courses: 'Courses',
      experts: {
        title: 'Experts',
        database: 'Database',
        interviews: 'Interviews'
      },
      apply: 'Apply Now',
      searchPlaceholder: 'Search...',
      login: 'Login',
      register: 'Register',
      userCenter: 'User',
      userCenter1: 'Center',
      logout: 'Logout'
    },
    footer: {
      about: 'About Us',
      aboutText: 'Company introduction text...',
      contact: 'Contact',
      address: 'Address: XXX',
      phone: 'Phone: XXX',
      email: 'Email: XXX',
      followUs: 'Follow Us',
      copyright: 'All Rights Reserved'
    },
    home: {
      companyCulture: 'Company Culture',
      developmentHistory: 'Development History',
      viewMore: 'View More',
      wantToKnowMore: 'Want to know more about Surun?',
      wantToKnowMoreEn: 'WANT TO KNOW MORE ABOUT SURUN?',
      more: 'View More',
    },
    group: {
      intro: 'Group Profile',
      members: 'Member Companies',
      culture: 'Corporate Culture',
      products: 'Products & Services',
      history: 'Development History',
      honors: 'Group Honors',
      partners: 'Partners',
      contact: 'Contact Information',
      join: 'Join Us',
      viewNow: 'View Details'
    },
    talentPage: {
      lifecycle: 'Talent Lifecycle Services',
      cases: 'Talent Service Cases',
      standard: 'Talent Service Standards'
    },
    enterpriseLifecycle: {
      lifecycle: 'Enterprise Lifecycle Services',
      luodi: 'Enterprise Landing Service',
      innovation: 'Innovation Qualification Management',
      system: 'Innovation System Construction',
      resource: 'Innovation Resource Connection'
    },
    governmentService: {
      service: 'Government Services',
      cases: 'High-Level Talent Aggregation Project',
      standard: 'Technology Innovation Remote Incubation Project',
      resource: 'High-Tech Enterprise and Innovation Project Development',
      cultivation: 'Industrial Cluster Cultivation',
      double:'Comprehensive Innovation Incubation',
      two:'Dual Recruitment and Dual Attraction'
    },
    talentPlan: {
      title: 'Talent Plan Interpretation',
      titleEn: 'TALENT PLAN INTERPRETATION',
      sections: {
        national: 'National Talent Programs',
        provincial: 'Provincial Talent Programs',
        city: 'Municipal Talent Programs'
      }
    },
    talentPlanDetail: {
      home: 'Home',
      talent: 'Talent Services',
      plan: 'Talent Programs',
      country:'Interpretation Details of National Talent Programs',
      Provincial:'Interpretation Details of Provincial Talent Programs',
      City:'Interpretation Details of City level Talent Programs',
      time: 'Release Time',
      location:'Quick Registration',
      title: 'Interpretation details of talent Programs',
    },
    recruitmentDetail: {
      home: 'Home',
      talent: 'Talent Services',
      recruitment:'Talent Recruitment',
      detail: 'Recruitment Details',
      time: 'Release Time',
      location:'Quick Registration',
      title: 'Recruitment Details',
      name: 'Name',
      level: 'Highest education level',
      school: 'Graduation school',
      major: 'major',
      phone:'Mobile phone number/WeChat ID',
      needs:'Your needs',
      message:'Message',
      highschool: 'University Job Search',
      enterprise: 'Enterprise Job Search',
      startup: 'Entrepreneurship',
      product: 'Industry-University-Research Cooperation',
    },
    talentPolicy: {
      breadcrumb: {
        home: 'Home',
        talent: 'Talent Services',
        policy: 'Talent Policy'
      },
      filter: {
        area: 'Area:',
        city: 'City:',
        all: 'All'
      },
      empty: {
        text: 'No policy information available'
      },
      button: {
        viewDetail: 'View Details'
      },
      date: 'Release Date:'
    },
    cities: {
      nanjing: 'Nanjing',
      wuxi: 'Wuxi',
      xuzhou: 'Xuzhou',
      changzhou: 'Changzhou',
      suzhou: 'Suzhou',
      nantong: 'Nantong',
      lianyungang: 'Lianyungang',
      huaian: "Huai'an",
      yancheng: 'Yancheng',
      yangzhou: 'Yangzhou',
      zhenjiang: 'Zhenjiang',
      taizhou: 'Taizhou',
      suqian: 'Suqian',
      jiangsu: 'Jiangsu'
    },
    recruitment: {
      breadcrumb: {
        home: 'Home',
        talent: 'Talent Services',
        recruitment: 'Talent Recruitment'
      },
      filter: {
        category: 'Category:',
        all: 'All'
      },
      categories: {
        powerEquipment: 'New Power Equipment',
        newEnergy: 'New Energy',
        iot: 'IoT',
        biomedical: 'Biomedicine',
        textiles: 'High-end Textiles',
        newMaterials: 'New Materials',
        semiconductor: 'Semiconductor',
        equipment: 'High-end Equipment',
        aerospace: 'Aerospace',
        shipbuilding: 'High-tech Ships & Marine Equipment',
        newEnergyVehicles: 'New Energy Vehicles',
        infoComm: 'New Generation ICT',
        environmental: 'Energy Conservation & Environmental Protection',
        newFood: 'New Food Industry',
        software: 'Software & Information Services',
        digital: 'Emerging Digital Industry',
        other: 'Others'
      },
      empty: {
        text: 'No recruitment information available'
      }
    },
    recommend: {
      breadcrumb: {
        home: 'Home',
        talent: 'Talent Services',
        recommend: 'Talent Recommendation'
      },
      filter: {
        category: 'Category:',
        all: 'All'
      },
      empty: {
        text: 'No recommendation information available'
      }
    },
    recommendDetail: {
      breadcrumb: {
        home: 'Home',
        talent: 'Talent Services',
        recommend: 'Talent Recommendation',
        detail: 'Recommendation Details'
      },
      title: 'Talent Recommendation Details',
      publishTime: 'Release Time:'
    },
    enterprisePolicy: {
      breadcrumb: {
        home: 'Home',
        enterprise: 'Enterprise Services',
        policy: 'Enterprise Policy'
      },
      filter: {
        policyType: 'Policy Type:',
        all: 'All'
      },
      types: {
        development: 'Development & Reform',
        industry: 'Industry & Information',
        science: 'Science & Technology',
        humanResource: 'Human Resources',
        other: 'Others'
      },
      empty: {
        text: 'No policy information available'
      },
      button: {
        viewDetail: 'View Details'
      },
      publishTime: 'Release Time:'
    },
    governmentCooperation: {
      breadcrumb: {
        home: 'Home',
        government: 'Government Services',
        // cooperation: 'Government Cooperation'
        cooperation: 'Cooperative Government Promotion',
      },
      filter: {
        area: 'Area:',
        city: 'City:',
        all: 'All'
      },
      empty: {
        text: 'No information available'
      },
      publishTime: 'Release Time:'
    },
    governmentCooperationDetail: {
      breadcrumb: {
        home: 'Home',
        government: 'Government Services',
        cooperation: 'Cooperative Government Promotion',
        detail: 'Promotion Details'
      },
      publishTime: 'Release Time:'
    },
    governmentInnovation: {
      breadcrumb: {
        home: 'Home',
        government: 'Government Services',
        innovation: 'Innovation Carrier'
      },
      filter: {
        area: 'Area:',
        city: 'City:',
        all: 'All'
      },
      empty: {
        text: 'No information available'
      },
      publishTime: 'Release Time:'
    },
    governmentInnovationDetail: {
      breadcrumb: {
        home: 'Home',
        government: 'Government Services',
        innovation: 'Innovation Carrier',
        detail: 'Innovation Carrier Details'
      },
      publishTime: 'Release Time:',
      title: 'Innovation Carrier Details'
    },
    activity: {
      breadcrumb: {
        home: 'Home',
        activity: 'Innovation Activities'
      },
      filter: {
        activityType: 'Activity Type:',
        all: 'All'
      },
      types: {
        surun: 'Surun Organizes',
        monthly: 'Monthly'
      },
      empty: {
        text: 'No activity information available'
      },
      time: 'Time:'
    },
    activityDetail: {
      breadcrumb: {
        home: 'Home',
        activity: 'Innovation Activities',
        detail: 'Activity Details',
        userCenter: 'User Center'
      },
      publishTime: 'Release Time:',
      title: 'Activity Details',
      quickApply: 'Quick Apply',
      collect: {
        collected: 'Collected',
        uncollected: 'Collect'
      },
      form: {
        title: 'Quick Application',
        name: 'Name',
        degree: 'Highest Degree',
        school: 'School',
        major: 'Major',
        contact: 'Phone/WeChat',
        needs: 'Your Needs',
        message: 'Message',
        submit: 'Submit',
        placeholder: {
          name: 'Please enter your name',
          degree: 'Please enter your highest degree',
          school: 'Please enter your school',
          major: 'Please enter your major',
          contact: 'Please enter your phone/WeChat',
          message: 'Please enter your message'
        },
        validation: {
          name: 'Please enter your name',
          degree: 'Please enter your highest degree',
          school: 'Please enter your school',
          major: 'Please enter your major',
          contact: 'Please enter your phone/WeChat',
          needs: 'Please select at least one need',
          message: 'Please enter your message'
        }
      },
      needOptions: ['University Job Search', 'Enterprise Job Search', 'Entrepreneurship', 'Industry-University-Research Cooperation']
    },
    news: {
      breadcrumb: {
        home: 'Home',
        news: 'News'
      },
      filter: {
        newsType: 'News Type:',
        all: 'All'
      },
      types: {
        group: 'Group News',
        industry: 'Industry News',
        notice: 'Announcements'
      },
      empty: {
        text: 'No news available'
      },
      publishTime: 'Release Time:',
      viewDetail: 'View Details'
    },
    newsDetail: {
      breadcrumb: {
        home: 'Home',
        news: 'News',
        detail: 'News Details'
      },
      publishTime: 'Release Time:'
    },
    courses: {
      breadcrumb: {
        home: 'Home',
        courses: 'Course Center'
      },
      filter: {
        courseType: 'Course Type:',
        all: 'All'
      },
      types: {
        public: 'Free',
        vip: 'VIP'
      },
      empty: {
        text: 'No courses available'
      },
      vipLock: {
        text: 'VIP Only',
        warning: 'This course is for VIP users only. Please upgrade to VIP first'
      }
    },
    coursesDetail: {
      breadcrumb: {
        home: 'Home',
        courses: 'Course Center',
        detail: 'Course Details'
      },
      publishTime: 'Release Time:',
      videoTitle: 'Video Course',
      contentTitle: 'Course Content Details'
    },
    expert: {
      breadcrumb: {
        home: 'Home',
        expert: 'Talent & Expert Database'
      },
      filter: {
        type: 'Type:',
        category: 'Category:',
        all: 'All'
      },
      types: {
        talent: 'Talent',
        expert: 'Expert'
      },
      empty: {
        text: 'No information available'
      },
      categories: {
        powerEquipment: 'New Power Equipment',
        newEnergy: 'New Energy',
        iot: 'IoT',
        biomedical: 'Biomedicine',
        textiles: 'High-end Textiles',
        newMaterials: 'New Materials',
        semiconductor: 'Semiconductor',
        equipment: 'High-end Equipment',
        aerospace: 'Aerospace',
        shipbuilding: 'High-tech Ships & Marine Equipment',
        newEnergyVehicles: 'New Energy Vehicles',
        infoComm: 'New Generation ICT',
        environmental: 'Energy Conservation & Environmental Protection',
        newFood: 'New Food Industry',
        software: 'Software & Information Services',
        digital: 'Emerging Digital Industry',
        other: 'Others'
      }
    },
    expertDetail: {
      breadcrumb: {
        home: 'Home',
        expert: 'Talent & Expert Database',
        detail: 'Details'
      },
      category: {
        title: 'Category:',
        talent: 'Talent',
        expert: 'Expert'
      },
      type: 'Talent Type:',
      title: 'Details'
    },
    interviews: {
      breadcrumb: {
        home: 'Home',
        interviews: 'Talent Interviews'
      },
      empty: {
        text: 'No videos available'
      },
      time: 'Time:'
    },
    userCenter: {
      changeAvatar: {
        text: 'Change Avatar'
      },
      changePhone: {
        title: 'ChangePhone',
        newPhone: 'Enter new phone number',
        code: 'Enter verification code',
        getCode: 'Get Code',
        retryCode: 's to retry',
        save: 'Save'
      },
      tabs: {
        savedPolicy: 'Saved Policies',
        savedActivity: 'Saved Activities',
        registeredActivity: 'Registration Management'
      },
      filter: {
        category: 'Category:',
        all: 'All',
        talent: 'Talent Policy',
        enterprise: 'Enterprise Policy'
      },
      empty: {
        policy: 'No saved policies',
        talentPolicy: 'No saved talent policies',
        enterprisePolicy: 'No saved enterprise policies',
        activity: 'No saved activities',
        signedActivity: 'No registered activities'
      }
    },
    policyDetail: {
      breadcrumb: {
        home: 'Home',
        userCenter: 'User Center',
        talent: 'Talent Service',
        policy: 'Talent Policy',
        detail: 'Policy Details'
      },
      publishTime: 'Release Time:',
      collect: {
        collected: 'Collected',
        uncollected: 'Collect'
      }
    },
    enterprisePolicyDetail: {
      breadcrumb: {
        home: 'Home',
        userCenter: 'User Center',
        enterprise: 'Enterprise Service',
        policy: 'Enterprise Policy',
        detail: 'Policy Details'
      },
      publishTime: 'Release Time:',
      collect: {
        collected: 'Collected',
        uncollected: 'Collect'
      }
    },
    applyNow: {
      breadcrumb: {
        home: 'Home',
        current: 'Apply Now'
      },
      title: 'Apply Now',
      sections: {
        basic: 'Basic Information',
        materials: 'Application Materials',
        intention: 'Development Intention',
        consultant: 'Consultant'
      },
      materialsTip: 'Please provide complete and authentic application materials for eligibility evaluation and talent recruitment review.',
      fields: {
        fullName: 'Full Name',
        passportNumber: 'Passport Number',
        consultant: 'Consultant'
      },
      placeholders: {
        fullName: 'Please enter your full name as shown on your identification document.',
        passportNumber: 'Please enter your passport number (for identity verification).',
        publicationText: 'Please provide publication details such as title, journal/conference, or DOI',
        developmentIntention: 'Please briefly describe your research direction, professional interests, and intended industry or institutional collaboration.',
        consultant: 'Please enter the name of the consultant or contact person assisting with your application.'
      },
      categories: {
        cv: 'Academic Curriculum Vitae (CV)',
        identity: 'Passport & Identification Documents',
        academic_certificate: 'Academic Certificates',
        employment: 'Employment Verification',
        project_experience: 'Project Experience Documentation',
        publication: 'Representative Publications',
        additional: 'Additional Supporting Documents (Optional)'
      },
      hints: {
        cv: 'Please upload your full Academic Curriculum Vitae (CV), including education, professional experience, and research achievements (multiple files allowed).',
        identity: 'Please upload your passport information page. Applicants from Mainland China, Hong Kong, Macau, and Taiwan must also provide a national ID or equivalent identification document (upload all files in this section).',
        academic_certificate: 'Please upload academic degree and certificate documents for your Bachelor\'s, Master\'s, and Doctoral levels where applicable. Providing complete educational records is recommended.',
        employment: 'Please upload employment and appointment verification documents. Providing a comprehensive record of your professional experience is recommended.',
        project_experience: 'Please upload supporting documents for projects you have led or participated in, such as project approval documents, completion reports, project agreements, achievement certificates, or other relevant materials.',
        publication: 'Please provide publication details or upload files (at least one required).',
        additional: 'You may upload additional supporting materials to strengthen your application, such as patent certificates, award certificates, research reports, or other relevant achievements.'
      },
      uploadPublicationFiles: 'Upload Supporting Documents',
      uploadBtn: 'Click to upload',
      uploading: 'Uploading',
      submitTip: 'By submitting, you confirm that all information provided is true and complete and agree to its use for evaluation and recruitment review.',
      submitBtn: 'Submit Application',
      submitSuccess: 'Submitted Successfully',
      submitSuccessConfirm: 'Confirm',
      uploadSuccess: 'File uploaded successfully',
      removeSuccess: 'File removed successfully',
      agreement: {
        title: 'Confidentiality Statement',
        description: 'To ensure the security of your personal information, all submitted materials will be used solely for talent evaluation and recruitment review. Please read and agree to the relevant terms before proceeding.',
        accept: 'Agree and Continue',
        close: 'Close'
      },
      validation: {
        fullName: 'Please enter your full name',
        passportNumber: 'Please enter your passport number',
        consultant: 'Please enter the consultant name',
        categoryRequired: 'Please upload at least one file for {name}',
        publicationRequired: 'Please provide publication details or upload at least one publication file',
        fileType: 'Unsupported file format. Allowed: pdf, doc, docx, xls, xlsx, ppt, pptx, zip, rar, 7z, jpg, jpeg, png',
        fileSize: 'Single file size cannot exceed 500MB',
        totalSize: 'Total upload size cannot exceed 2GB',
        agreementFirst: 'Please read and accept the confidentiality agreement first'
      }
    }
  }
}

const i18n = new VueI18n({
  locale: 'zh',
  fallbackLocale: 'en',
  messages
})

export default i18n 